function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M55 -6.00798e-05L0 54.9999L55 110L110 54.9999L55 -6.00798e-05Z",
  fill: "#005885"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M74.446 72.8922H30.0427C29.4821 72.8922 29.0383 72.4484 29.0383 71.8878C29.0383 71.3272 29.4821 70.8834 30.0427 70.8834H74.446C75.0066 70.8834 75.4505 71.3272 75.4505 71.8878C75.4505 72.4484 75.0066 72.8922 74.446 72.8922Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M56.2736 72.8921C55.713 72.8921 55.2692 72.4483 55.2692 71.8877V45.6568H49.2195V71.8877C49.2195 72.4483 48.7757 72.8921 48.2151 72.8921C47.6545 72.8921 47.2107 72.4483 47.2107 71.8877V45.6568C47.2107 44.5356 48.1217 43.648 49.2195 43.648H55.2692C56.3903 43.648 57.2779 44.559 57.2779 45.6568V71.8877C57.2779 72.4483 56.8341 72.8921 56.2736 72.8921Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M43.1698 72.8922C42.6092 72.8922 42.1654 72.4484 42.1654 71.8878V54.7431H36.1157V71.8878C36.1157 72.4484 35.6719 72.8922 35.1113 72.8922C34.5507 72.8922 34.1069 72.4484 34.1069 71.8878V54.7431C34.1069 53.6219 35.0179 52.7343 36.1157 52.7343H42.1654C43.2866 52.7343 44.1742 53.6453 44.1742 54.7431V71.8878C44.1742 72.4484 43.7304 72.8922 43.1698 72.8922Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M69.4008 72.8922C68.8402 72.8922 68.3964 72.4484 68.3964 71.8878V37.5751C68.3964 37.0145 68.8402 36.5707 69.4008 36.5707H71.3395L65.3598 29.0961L59.3802 36.5707H61.3189C61.8795 36.5707 62.3233 37.0145 62.3233 37.5751V71.8878C62.3233 72.4484 61.8795 72.8922 61.3189 72.8922C60.7583 72.8922 60.3145 72.4484 60.3145 71.8878V38.5794H57.278C56.8809 38.5794 56.5306 38.3692 56.3671 38.0189C56.2036 37.6685 56.2503 37.248 56.4839 36.9444L64.5657 26.8538C64.9394 26.3633 65.7569 26.3633 66.1307 26.8538L74.2125 36.9444C74.4461 37.248 74.4928 37.6685 74.3293 38.0189C74.1658 38.3692 73.8154 38.5794 73.4183 38.5794H70.3818V71.8878C70.3818 72.4484 69.938 72.8922 69.3774 72.8922H69.4008Z",
  fill: "white"
});

function SvgC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.f609c131.svg";
export { ForwardRef as ReactComponent };